import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import CultureBonus from "@/roc/effects/CultureBonus/CultureBonus";
import CultureAmount from "@/roc/effects/CultureBonus/CultureAmount";
import CultureRange from "@/roc/effects/CultureBonus/CultureRange";

const AztecGardenBath = {
  id: '162',
  name: "Aztec Garden Bath",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Aztec_Garden_Bath',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Aztec_Garden_Bath',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_DAMAGE_MOD,
      EffectAmount.asPerLevel([1.1,1.2,1.4,1.5,1.6,1.8,1.9,2,2.1,2.2,2.4,2.5,2.6,2.8,2.9,3,3.1,3.2,3.4,3.5,3.6,3.8,3.9,4,4.1,4.2,4.4,4.5,4.6,4.8,4.9,5,5.1,5.2,5.4,5.5,5.6,5.8,5.9,6,6.1,6.2,6.4,6.5,6.6,6.8,6.9,7,7.1,7.2,7.4,7.5,7.6,7.8,7.9,8,8.1,8.2,8.4,8.5]),
      '%'
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        4200,6350,8100,9650,11000,12300,13450,14600,15650,16700,17650,18600,19550,20400,21300,22100,22950,23750,24500,25300,26050,26800,27500,28200,28900,29600,30300,30950,31600,32250,32900,33550,34150,34750,35400,36000,36600,37150,37750,38350,38900,39450,40050,40600,41150,41700,42250,42750,43300,43800,44350,44850,45400,45900,46400,46900,47400,47900,48400,48900
      ]).withOutput(ProductionOutputType.FOOD),
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          56,60,64,68,72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292
        ],
        bronzeAge: [
          70,75,80,85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365
        ],
        minoanEra: [
          84,90,96,102,108,114,120,126,132,138,144,150,156,162,168,174,180,186,192,198,204,210,216,222,228,234,240,246,252,258,264,270,276,282,288,294,300,306,312,318,324,330,336,342,348,354,360,366,372,378,384,390,396,402,408,414,420,426,432,438
        ],
        classicGreece: [
          98,105,112,119,126,133,140,147,154,161,168,175,182,189,196,203,210,217,224,231,238,245,252,259,266,273,280,287,294,301,308,315,322,329,336,343,350,357,364,371,378,385,392,399,406,413,420,427,434,441,448,455,462,469,476,483,490,497,504,511
        ],
        earlyRome: [
          112,120,128,136,144,152,160,168,176,184,192,200,208,216,224,232,240,248,256,264,272,280,288,296,304,312,320,328,336,344,352,360,368,376,384,392,400,408,416,424,432,440,448,456,464,472,480,488,496,504,512,520,528,536,544,552,560,568,576,584
        ],
        romanEmpire: [
          126,135,144,153,162,171,180,189,198,207,216,225,234,243,252,261,270,279,288,297,306,315,324,333,342,351,360,369,378,387,396,405,414,423,432,441,450,459,468,477,486,495,504,513,522,531,540,549,558,567,576,585,594,603,612,621,630,639,648,657
        ],
        byzantineEra: [
          140,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730
        ],
        ageOfTheFranks: [
          154,165,176,187,198,209,220,231,242,253,264,275,286,297,308,319,330,341,352,363,374,385,396,407,418,429,440,451,462,473,484,495,506,517,528,539,550,561,572,583,594,605,616,627,638,649,660,671,682,693,704,715,726,737,748,759,770,781,792,803
        ],
        feudalAge: [
          168,180,192,204,216,228,240,252,264,276,288,300,312,324,336,348,360,372,384,396,408,420,432,444,456,468,480,492,504,516,528,540,552,564,576,588,600,612,624,636,648,660,672,684,696,708,720,732,744,756,768,780,792,804,816,828,840,852,864,876
        ],
        iberianEra: [
          182,195,208,221,234,247,260,273,286,299,312,325,338,351,364,377,390,403,416,429,442,455,468,481,494,507,520,533,546,559,572,585,598,611,624,637,650,663,676,689,702,715,728,741,754,767,780,793,806,819,832,845,858,871,884,897,910,923,936,949
        ],
        kingdomOfSicily: [
          196,210,224,238,252,266,280,294,308,322,336,350,364,378,392,406,420,434,448,462,476,490,504,518,532,546,560,574,588,602,616,630,644,658,672,686,700,714,728,742,756,770,784,798,812,826,840,854,868,882,896,910,924,938,952,966,980,994,1008,1022
        ],
        highMiddleAges: [
          210,225,240,255,270,285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050,1065,1080,1095
        ],
        earlyGothicEra: [
          224,240,256,272,288,304,320,336,352,368,384,400,416,432,448,464,480,496,512,528,544,560,576,592,608,624,640,656,672,688,704,720,736,752,768,784,800,816,832,848,864,880,896,912,928,944,960,976,992,1008,1024,1040,1056,1072,1088,1104,1120,1136,1152,1168
        ],
        lateGothicEra: [
          238,255,272,289,306,323,340,357,374,391,408,425,442,459,476,493,510,527,544,561,578,595,612,629,646,663,680,697,714,731,748,765,782,799,816,833,850,867,884,901,918,935,952,969,986,1003,1020,1037,1054,1071,1088,1105,1122,1139,1156,1173,1190,1207,1224,1241
        ]
      }),
      CultureRange.asCallbackWithLevel(
        (level) => {
          if (level < 20) {
            return 1;
          }
          if (level < 60) {
            return 2;
          }
          return 4;
        }
      )
    )
  ]),
};

export default AztecGardenBath;
